//layout grid 的自适应组件
const {ccclass, menu,property} = cc._decorator;

@ccclass
export class autoLayout extends cc.Layout
{
    @property(cc.Vec2)
    position:cc.Vec2 = null;
    onLoad()
    {
        //this.resetPosition();
    }
    resetPosition()
    {
        if(this.resizeMode == cc.Layout.ResizeMode.CHILDREN&&this.type ==cc.Layout.Type.GRID)
        {
            var array = this.node.children;
            var count = 0;
            array.forEach(element => {
                if(element.active)
                {
                    count++;
                }
            });
            var len = array.length - count;
            if(len<1)
            {
                return;
            }
            cc.log("len:",len,count);
        }
        if(this.startAxis == cc.Layout.AxisDirection.HORIZONTAL)
        {
            var offect = (this.cellSize.width/2)*len
            cc.log("(this.cellSize.width/2)*len:",(this.cellSize.width/2)*len);
            this.node.position = cc.v2(this.position.x+offect+this.spacingX,this.position.y);
            cc.log("通过layout设置位置：",this.node.position);
        }
        else if(this.startAxis == cc.Layout.AxisDirection.VERTICAL)
        {
            var offect = (this.cellSize.height/2)*len
            this.node.position = cc.v2(this.position.x,this.position.y+offect+this.spacingY);
        }
    }
}
